import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
} from '@angular/core';

@Component({
  selector: 'app-password-strength-bar',
  templateUrl: './password-strength-bar.component.html',
  styleUrls: ['./password-strength-bar.component.scss'],
})
export class PasswordStrengthBarComponent implements OnChanges {
  @Input() passwordToCheck: string;
  @Input() barLabel: string;
  @Output() strengthLvl = new EventEmitter();
  @Output() strengthDetails = new EventEmitter();
  score: number = 0;
  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  bar4: string;

  private colors = ['#a32424', '#cea05b', '#c4c45c', '#d6d971', '#65da65'];

  private static measureStrength(pass: string): any {
    const variations = {
      digits: /\d/.test(pass),
      // Support both English (a-z, A-Z) and Russian/Cyrillic (а-я, А-Я) uppercase and lowercase
      lower: /[a-zа-я]/.test(pass),
      upper: /[A-ZА-Я]/.test(pass),
      nonWords: /[\W_]/.test(pass),
    };

    const variationsItems: any = {};
    let criteriaCount = 0;

    for (const check in variations) {
      variationsItems[check] = variations[check];
      if (variations[check]) {
        criteriaCount++;
      }
    }

    variationsItems.minlength = pass.length >= 8;
    if (variationsItems.minlength) {
      criteriaCount++;
    }

    const score = criteriaCount * 20;

    return {
      score: score,
      variationsItems,
    };
  }

  private getColor(score: number): any {
    let idx = 0;
    if (score >= 100) {
      idx = 4;
    } else if (score >= 80) {
      idx = 3;
    } else if (score >= 60) {
      idx = 2;
    } else if (score >= 40) {
      idx = 1;
    } else if (score >= 20) {
      idx = 0;
    } else {
      return {
        idx: 0,
        col: this.colors[0],
      };
    }
    return {
      idx: idx + 1,
      col: this.colors[idx],
    };
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes['passwordToCheck'].currentValue;
    this.setBarColors(5, '#DDD');
    if (password) {
      const strength = PasswordStrengthBarComponent.measureStrength(password);
      this.score = strength.score;
      const c = this.getColor(strength.score);
      this.setBarColors(c.idx, c.col);
      this.strengthLvl.emit(strength.score);
      this.strengthDetails.emit(strength);
    }
  }

  private setBarColors(count, col): void {
    for (let _n = 0; _n < count; _n++) {
      this['bar' + _n] = col;
    }
  }
}
